const Getters = {
  getStorageListFromState: (state) => {
    return state.storageList
  }
}

export default Getters
